export default {
  htmlView: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};
